import React, { FunctionComponent } from 'react';
import CirclePerson from 'dibs-vg/dist/react/circle-person';
import CircleProfessional from 'dibs-vg/dist/react/circle-professional';
import classnames from 'classnames';

import style from './MatchmakerIcon.scss';

type MatchmakerIconProps = {
    wrapperClass?: string;
    iconWrapperClass?: string;
    personClass?: string;
    professionalClass?: string;
    dividerClass?: string;
};

export const MatchmakerIcon: FunctionComponent<MatchmakerIconProps> = props => {
    const wrapperClass = classnames(style.wrapper, props.wrapperClass);
    const iconWrapperClass = classnames(style.iconWrapper, props.iconWrapperClass);
    const personClass = classnames(style.person, props.personClass);
    const professionalClass = classnames(style.professional, props.professionalClass);
    const dividerClass = classnames(style.divider, props.dividerClass);

    return (
        <div className={style.container}>
            <div className={wrapperClass}>
                <span className={iconWrapperClass}>
                    <CirclePerson className={personClass} />
                </span>
                <span className={dividerClass} />
                <span className={iconWrapperClass}>
                    <CircleProfessional className={professionalClass} />
                </span>
            </div>
        </div>
    );
};
